export const ESPECIALIDAD = {
  OFTALMOLOGO : '0000000135',
  GASTRO      : '0000000515',
  NEUMOLOGO   : '0000000514',
  ONCOLOGO    : '0000000521',
  ALERGOLOGO  : '019',
  CARDIOLOGIA : '0000000112',
  TRAUMATOLOGO: '012',
  UROLOGO     : '0000000540',
  ENDOCRINO   : '0000000520',
  DERMATOLOGO : '0000000524',
  FISIATRIA   : '0000000126',
  OTORRINO    : '0000000136',
  NUTRICION   : '0000000573',
  PSICOLOGIA  : '0000000522',
  PEDIATRA    : '0000000107',
  GINECOLOGO  : '0000000148',
  ODONTOLOGIA : '0000000134'
};



export const MEDICO_DERIVACIONES = {
  IMAGENES       : '88',
  LABORATORIOS   : '90',
  PROCEDIMIENTOS : '101', 
}